"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = void 0;
var CalendarPicker_styles_1 = require("../CalendarPicker/CalendarPicker.styles");
var getStyles = function (props) {
    /*  Return styles from the base class.
     *  If this component has extra styles not in the base, apply them here i.e.:
     *  const myStyle: IStyle = {
     *    display: "block"
     *  };
     *  return {...getPickerStyles(props), myStyle};
     */
    return CalendarPicker_styles_1.getStyles(props);
};
exports.getStyles = getStyles;
//# sourceMappingURL=CalendarYear.styles.js.map